import Vue from "vue";

export default {
    install () {
        Vue.prototype.$getAllTargets = async function() {
            let result = [];
            try {
                const response = await this.$http.get('/target');
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };

        Vue.prototype.$getAllApproveTargets = async function() {
            let result = [];
            try {
                const response = await this.$http.get('/target?activate=0');
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };

        Vue.prototype.$getTargetOfMine = async function() {
            let result = [];
            try {
                const response = await this.$http.get('/target?createdBy=' + this.$getUserID);
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };

        Vue.prototype.$getTargetInContext = async function() {
            let result = [];
            try {
                const response = await this.$http.get('/target/context/' + this.$getUserContextID);
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };

        Vue.prototype.$getApproveTargetOfMine = async function() {
            let result = [];
            try {
                const response = await this.$http.get('/target/approveByMe/' + this.$getUserID);
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };

        Vue.prototype.$getApproveTargetInContext = async function() {
            let result = [];
            try {
                const response = await this.$http.get('/target/approve/' + this.$getUserContextID);
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };
    },
};